import React from "react";
import './LoadingDots.css'

export const LoadingDots = () => {
  return (
      <>
        <span className="LoadingDot">.</span>
        <span className="LoadingDot">.</span>
        <span className="LoadingDot">.</span>
      </>
  );
}